'use strict';

var ROMSummaryKpiFilterFactory = function ROMSummaryKpiFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['ROMOptGroupWeekFilterFactory', 'ROMSummaryCabinFilterFactory', 'ROMSummaryPOSFilterFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function ROMSummaryKpiFilter() {
    DemandFilter.call(this, ['rom-summary-mode'], ['kpi-ribbon']);
    this.registerFilters(injectedFilters);
  }
  ROMSummaryKpiFilter.constructor = ROMSummaryKpiFilter;
  ROMSummaryKpiFilter.prototype = Object.create(DemandFilter.prototype);
  ROMSummaryKpiFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType.indexOf(sourceType) !== -1 && this.targetType.indexOf(targetType) !== -1;
  };
  return ROMSummaryKpiFilter;
};
ROMSummaryKpiFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ROMSummaryKpiFilterFactory;